import axios from '@/jslib/axios'

export const getAnnualTravelList = (params,other) => {
  return axios({
    method: 'get',
    url: '/admin/annual/travel/gift/list',
    params,
    ...other
  })
}
export const getAnnualTravelCodeList = (params) => {
  return axios({
    method: 'get',
    url: '/admin/annual/travel/gift/code/list',
    params,
  })
}
export const getAnnualTravelExport = (params) => {
  return axios({
    method: 'get',
    url: '/admin/annual/travel/gift/export',
    params,
    timeout: 120000
  })
}
export const getPopTravellerList = (params,other) => {
  return axios({
    method: 'get',
    url: '/admin/pop/traveller/list',
    params,
    ...other
  })
}
